import(/* webpackMode: "eager", webpackExports: ["ClientMyLayout"] */ "/builds/tradingvalley-frontend/growin/apps/web/app/[lang]/my/ClientMyLayout.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["EventBanner"] */ "/builds/tradingvalley-frontend/growin/apps/web/components/event-banner/EventBanner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WatchlistContextProvider"] */ "/builds/tradingvalley-frontend/growin/apps/web/context/use-context/watchlist-provider/client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/tradingvalley-frontend/growin/apps/web/features/analysis/layouts/components/navigation-panel/NavigationPanel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MyContent"] */ "/builds/tradingvalley-frontend/growin/apps/web/layouts/my-content/components/MyContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MyNavbar"] */ "/builds/tradingvalley-frontend/growin/apps/web/layouts/my-navbar/components/MyNavbar.tsx");
